import { useParams } from 'react-router';
import { Parameters } from 'constants/queryParameters';

export const useQueryParams = (key: Parameters) => useParams()[key];
